import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from '../api';
import { Response } from '../genericInterface';
import { IIssuerRequest, IIssuerRequestStats } from './interface';
import { paginatedResponse } from '../paginatedInterface';

export const issuerRequestApi = createApi({
    reducerPath: 'issuerRequestApi',
    baseQuery: baseQuery,
    tagTypes: ['issuerRequest'],
    endpoints: (builder) => ({
        getAllIssuerRequest: builder.query<
            paginatedResponse<IIssuerRequest[]>,
            { perPage: number; currentPage: number }
        >({
            query: ({ perPage, currentPage }) => ({
                url: `/loan/api/v1/issuer-request?perPage=${perPage}&currentPage=${currentPage}`,
                method: 'GET',
            }),
            providesTags: ['issuerRequest'],
        }),
        deleteIssuerRequest: builder.mutation<Response<IIssuerRequest>, string>(
            {
                query: (issuerId) => ({
                    url: `/loan/api/v1/issuer-request/${issuerId}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['issuerRequest'],
            },
        ),
        getSingleIssuerRequest: builder.query<Response<IIssuerRequest>, string>(
            {
                query: (issuerId) => ({
                    url: `/loan/api/v1/issuer-request/${issuerId}`,
                    method: 'GET',
                }),
            },
        ),
        issuerRequestStats: builder.query<Response<IIssuerRequestStats>, void>({
            query: () => ({
                url: `/loan/api/v1/issuer-request/a/stats`,
                method: 'GET',
            }),
            providesTags: ['issuerRequest'],
        }),
        updateIssuerRequest: builder.mutation<
            Response<IIssuerRequest>,
            {
                requestStatus: string;
                authorizedBy: string | null;
                issuerRequestId: string;
            }
        >({
            query: ({ requestStatus, authorizedBy, issuerRequestId }) => ({
                url: `/loan/api/v1/issuer-request/manage-issuer-request/${issuerRequestId}`,
                method: 'PUT',
                body: { requestStatus, authorizedBy },
            }),
            invalidatesTags: ['issuerRequest'],
        }),
    }),
});

export const {
    useGetAllIssuerRequestQuery,
    useGetSingleIssuerRequestQuery,
    useDeleteIssuerRequestMutation,
    useIssuerRequestStatsQuery,
    useUpdateIssuerRequestMutation,
} = issuerRequestApi;
